import { type ElementPosition, getCoordinates } from 'modules/ai_voice/lib/dom'
import './cursor.css'

declare global {
  interface Window {
    cursor?: HTMLElement
  }
}

export function getCursor(): HTMLElement {
  if (!window.cursor) {
    const cursor = document.createElement('div')
    cursor.className = 'ai-cursor ai-cursor-idle'
    document.body.appendChild(cursor)
    window.cursor = cursor
  }
  return window.cursor
}

export async function animateCursorMove(
  element: HTMLElement,
  position: ElementPosition = 'center',
  speed = 3
): Promise<void> {
  const targetPos = getCoordinates(element, position)
  const cursor = getCursor()
  const prevPos = getCoordinates(cursor)

  const distance = Math.sqrt((targetPos.x - prevPos.x) ** 2 + (targetPos.y - prevPos.y) ** 2)
  const duration = Math.pow(distance, 0.25) / speed

  cursor.classList.remove('ai-cursor-idle')
  cursor.style.transition = `left ${duration}s cubic-bezier(.25,1,.5,1), top ${duration}s cubic-bezier(.25,1,.5,1)`
  cursor.style.left = `${targetPos.x}px`
  cursor.style.top = `${targetPos.y}px`
  await new Promise<void>((resolve) => setTimeout(resolve, duration * 1000))
  cursor.classList.add('ai-cursor-idle')
}

export async function animateCursorClick(duration = 200): Promise<void> {
  const cursor = getCursor()
  cursor.classList.remove('ai-cursor-idle')
  cursor.classList.add('ai-cursor-clicking')
  await new Promise<void>((resolve) => setTimeout(resolve, duration))
  cursor.classList.remove('ai-cursor-clicking')
  cursor.classList.add('ai-cursor-idle')
}

export function removeCursor(): void {
  if (window.cursor) {
    window.cursor.remove()
    delete window.cursor
  }
}
